import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/ateliers/$atelierId/")({
  component: () => {
    const { atelierId } = Route.useParams();
    return <Navigate to="/ateliers/$atelierId/igold-transactions" params={{ atelierId }} replace />;
  },
});
